import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {State} from '../index';
import {Injectable} from '@angular/core';
import {debounceTime, filter, map, tap, withLatestFrom, sampleTime, take} from 'rxjs/operators';
import {get} from 'lodash';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';

import * as courses from '../courses/actions';
import { FacebookPixelEventTrackerService } from 'src/app/facebook-pixel-event-tracker.service';
import { combineLatest } from 'rxjs';

import { Angulartics2Intercom } from 'angulartics2/intercom';
import {donateClicked} from '../ui';

@Injectable()
export class AnalyticsEffects {
	donationClicks$ = createEffect(() => this.actions$.pipe(
		ofType(donateClicked),
		tap(action => {
			this.intercom.eventTrack('donateClicked', {donationUrl: action.donateUrl});
		})
	), {dispatch: false});

	videoPlay$ = createEffect(() => this.actions$.pipe(
		ofType(courses.setVideoPlay),
		tap(action => {
			// this.facebookPixelEventTracker.trackEvent('VideoPlay', { content_ids: [action.videoId] }, true);
		})
	), {dispatch: false});

	videoProgress$ = createEffect(() => this.actions$.pipe(
		ofType(courses.setVideoProgress, courses.setVideoProgressForce),
		sampleTime(10000),
		tap(action => {
			window.dataLayer.push({
				event: 'videoProgress',
				videoProgressLabel: window.location + '|' + action.videoId,
			});
		})
	), {dispatch: false});

	videoComplete$ = createEffect(() => this.actions$.pipe(
		ofType(courses.setVideoReachedEnd),
		tap(action => {
			this.facebookPixelEventTracker.trackEvent('VideoComplete', { video_id: action.videoId }, true);
		})
	), {dispatch: false});

	constructor(
		private actions$: Actions,
		private router: Router,
		private currentRoute: ActivatedRoute,
		private store: Store<State>,
		private facebookPixelEventTracker: FacebookPixelEventTrackerService,
		private intercom: Angulartics2Intercom
	) {
		intercom.startTracking();
	}
}

